export const BuildInfo = {timestamp:1772382796000}
